/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roughly 18.66px and bold, or 24px and up regardless of weight. Large text has a lower contrast requirement because it is easier to read.`)
};

const es_cc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproximadamente 18,66 px y negrita, o 24 px en adelante sin importar el grosor. El texto grande tiene un requisito de contraste menor porque es más fácil de leer.`)
};

const de_cc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwa ab 18,66 px in Fett oder ab 24 px unabhängig vom Schriftschnitt. Großer Text hat eine geringere Kontrastanforderung, weil er leichter lesbar ist.`)
};

const nl_cc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeveer 18,66px en vetgedrukt, of 24px en groter ongeacht de dikte. Grote tekst heeft een lagere contrasteis omdat hij makkelijker leesbaar is.`)
};

const fr_cc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Environ 18,66px en gras, ou 24px et plus quelle que soit la graisse. Le grand texte a une exigence de contraste plus basse car il est plus facile à lire.`)
};

const it_cc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Circa 18,66px in grassetto, oppure 24px e oltre indipendentemente dallo spessore. Il testo grande ha un requisito di contrasto più basso perché è più facile da leggere.`)
};

const pt_br2_cc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproximadamente 18,66px em negrito, ou 24px ou mais independente do peso da fonte. Texto grande tem uma exigência de contraste menor porque é mais fácil de ler.`)
};

const pt_cc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproximadamente 18,66px a negrito, ou 24px ou mais independentemente do peso. O texto grande tem uma exigência de contraste menor porque é mais fácil de ler.`)
};

const ja_cc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`おおよそ18.66px以上の太字、または太さに関わらず24px以上です。大きいテキストは読みやすいため、コントラスト要件が低くなっています。`)
};

const zh_cc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大致为 18.66px 加粗，或 24px 及以上（不论字重）。大号文字更易阅读，因此对比度要求较低。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_faq_a2", locale)
	if (locale === "en") return en_cc_faq_a2(inputs)
	if (locale === "es") return es_cc_faq_a2(inputs)
	if (locale === "de") return de_cc_faq_a2(inputs)
	if (locale === "nl") return nl_cc_faq_a2(inputs)
	if (locale === "fr") return fr_cc_faq_a2(inputs)
	if (locale === "it") return it_cc_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_cc_faq_a2(inputs)
	if (locale === "pt") return pt_cc_faq_a2(inputs)
	if (locale === "ja") return ja_cc_faq_a2(inputs)
	return zh_cc_faq_a2(inputs)
};